/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  PostTournamentsIdPublishMutationResponse,
  PostTournamentsIdPublishPathParams,
} from "../types/PostTournamentsIdPublish.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postTournamentsIdPublishMutationKey = () =>
  [{ url: "/tournaments/:id/publish" }] as const;

export type PostTournamentsIdPublishMutationKey = ReturnType<
  typeof postTournamentsIdPublishMutationKey
>;

/**
 * @summary Публикация турнира (переход из Draft в Upcoming)
 * {@link /tournaments/:id/publish}
 */
export async function postTournamentsIdPublish(
  id: PostTournamentsIdPublishPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostTournamentsIdPublishMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "POST", url: `/tournaments/${id}/publish`, ...requestConfig });
  return res;
}

export function postTournamentsIdPublishMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const mutationKey = postTournamentsIdPublishMutationKey();
  return mutationOptions<
    ResponseConfig<PostTournamentsIdPublishMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: PostTournamentsIdPublishPathParams["id"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return postTournamentsIdPublish(id, config);
    },
  });
}

/**
 * @summary Публикация турнира (переход из Draft в Upcoming)
 * {@link /tournaments/:id/publish}
 */
export function usePostTournamentsIdPublish<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<PostTournamentsIdPublishMutationResponse>,
      ResponseErrorConfig<Error>,
      { id: PostTournamentsIdPublishPathParams["id"] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postTournamentsIdPublishMutationKey();

  const baseOptions = postTournamentsIdPublishMutationOptions(
    config,
  ) as UseMutationOptions<
    ResponseConfig<PostTournamentsIdPublishMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: PostTournamentsIdPublishPathParams["id"] },
    TContext
  >;

  return useMutation<
    ResponseConfig<PostTournamentsIdPublishMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: PostTournamentsIdPublishPathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ResponseConfig<PostTournamentsIdPublishMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: PostTournamentsIdPublishPathParams["id"] },
    TContext
  >;
}
